import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, modal, utils, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import * as objednavkaActions from "../actions/objednavkaActions";
import ParametryObjednavkyForm from "../forms/operator/ParametryObjednavkyForm";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import * as ciselnikActions from "../actions/ciselnikActions";
import * as uzivatelActions from "../actions/uzivatelActions";
import * as opravneniActions from "../actions/opravneniActions";
import NakladoveStrediskoObjednavkaForm from "../forms/operator/NakladoveStrediskoObjednavkaForm";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující parametry objednávky.
 */
class ParametryObjednavkyPanel extends Component<WithTranslation> {

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // VO objednávky
        zakaznikData: PropTypes.object, // VO dat o zákaznikovi
        readOnly: PropTypes.bool, // zda je panel v režimu read-only, tj. nezobrazuje tlačítko pro úpravu, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {loggedInUser, objednavka, aktivniSpolecnostId} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(ciselnikActions.fetchUkonyIfNeeded());
        if (objednavka.id) {
            this.props.dispatch(objednavkaActions.fetchObjednavkaRightsIfNeeded(objednavka.id));
        }
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUser.data.id));
        }
        if (aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching && aktivniSpolecnostId.data) {
            this.props.dispatch(ciselnikActions.fetchNakladovaStrediskaIfNeeded(aktivniSpolecnostId.data));
        }
    };

    handleUpravit = () => {
        const {objednavka, ukonyList, t} = this.props;
        // Ze serveru získáváme UkonVO/UkonPolozkaVO ze kterých se vybírá z comboboxu, ale v datech jdoucích na server jsou ObjednavkaUkonVO
        // - musíme namapovat nejprve UkonPolozkaVO do initialValues a následně je mapovat zpět do ObjednavkaUkonVO pro odeslání na server
        const initialValues = {
            ukony: {},
            ...objednavka
        };
        objednavka.objednavkaUkonList.forEach(objednavkaUkon => {
            const matchingUkon = ukonyList.rows.find(ukon => ukon.id === objednavkaUkon.idUkon);
            if (matchingUkon) {
                const matchingPolozka = matchingUkon.polozky.find(p => p.id === objednavkaUkon.ukonPolozkaId);
                if (matchingPolozka) {
                    initialValues.ukony[matchingUkon.id] = matchingPolozka;
                }
            }
        });
        this.props.dispatch(modal.ModalActions.show(
            ParametryObjednavkyForm,
            {
                onSubmit: (data) => {
                    const {ukony, ...submitData} = data;
                    const objednavkaUkonList = [];
                    Object.keys(ukony).forEach((key) => {
                        if (data.ukony[key]) {
                            objednavkaUkonList.push({
                                ukonPolozkaId: data.ukony[key].id,
                            });
                        }
                    });
                    const {pocetVyhotoveni, razitkovat, razCiselnaRada, poznamka, poznamkaInterni} = submitData;
                    const updateParams = {
                        pocetVyhotoveni,
                        razitkovat,
                        razCiselnaRada,
                        poznamka,
                        poznamkaInterni,
                        objednavkaUkonList
                    };
                    return ObjednavkaApi.updateObjednavkaParametry(objednavka.id, updateParams);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                    dispatch(objednavkaActions.invalidateObjednavky());
                    objednavkaActions.notifyIfNeeded(result);
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: initialValues,
                ukonyList: ukonyList.rows
            },
            t('order.edit_parameters'),
            {size: "md"}
        ))
    };

    handleUpravitNaklStred = () => {
        const {objednavka, nakladovaStrediskaList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            NakladoveStrediskoObjednavkaForm,
            {
                onSubmit: (data) => {
                    const naklStredEditVO = {
                        naklStredObjednavka: data.naklStredObjednavka
                    };
                    return ObjednavkaApi.updateObjednavkaNakladStred(objednavka.id, naklStredEditVO);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {naklStredObjednavka: objednavka.naklStredObjednavka},
                nakladovaStrediskaList: nakladovaStrediskaList.rows,
            },
            t('order.edit_name_center'),
            {size: "sm"}
        ))
    };

    renderActions = () => {
        const {readOnly, objednavkaRights, withoutRights, t} = this.props;
        let content = [];
        if (!readOnly) {
            content.push(<Button key={"btnUpravit"} onClick={this.handleUpravit}>{t('edit')}</Button>);
        }
        if (!withoutRights && objednavkaRights.data.editObjNaklStred) {
            content.push(<Button key={"btnUpravitNaklStred"} onClick={this.handleUpravitNaklStred}>{t('order.edit_name_action')}</Button>);
        }
        return <ButtonToolbar>
            {content}
        </ButtonToolbar>;
    };

    render() {
        const {t} = this.props;

        const objednavka = this.props.objednavka;
        const zakaznikData = this.props.zakaznikData;
        const objednavkaRightsDetail = this.props.objednavkaRights;
        const withoutRights = this.props.withoutRights;
        const objednavkaRights = objednavkaRightsDetail.data;

        if (!withoutRights && !objednavkaRightsDetail.fetched) {
            return <Loader />;
        }

        const showInterniPoznamka = !withoutRights && objednavkaRights.editObjIntPoznamka;
        let nazevObjednavky;
        if (zakaznikData && zakaznikData.naklStredObjednavka) {
            if (zakaznikData.naklStredObjednavka.nazevStredisko) {
                nazevObjednavky = zakaznikData.naklStredObjednavka.nazevStredisko;
            } else {
                nazevObjednavky = zakaznikData.naklStredObjednavka;
            }
        } else {
            nazevObjednavky = objednavka.naklStredObjednavka;
        }

        return <Card>
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('order.parameters')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xs={4}>
                        <DetailValue label={t('order.number_of_copies')}>{objednavka.pocetVyhotoveni}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('order.stamping')}>{objednavka.razitkovat ? "Ano" : "Ne"}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('order.number_series')}>{objednavka.razCiselnaRada ? objednavka.razCiselnaRada : objednavka.ciselnaRada}</DetailValue>
                    </Col>
                    {objednavka.objednavkaUkonList.map(ukon =>
                        <Col xs={4} key={ukon.id}>
                            <DetailValue label={ukon.nazevUkon}>{ukon.popisUkonPolozka ? ukon.popisUkonPolozka : ukon.popisUkon}</DetailValue>
                        </Col>
                    )}
                    <Col xs={4}>
                        <DetailValue label={t('order.name')}>{nazevObjednavky}</DetailValue>
                    </Col>
                    <Col xs={12}>
                        <DetailValue label={t('order.customer_note')}>{objednavka.poznamka}</DetailValue>
                    </Col>
                    {showInterniPoznamka && <Col xs={12}>
                        <DetailValue label={t('order.internal_note')}>{objednavka.poznamkaInterni}</DetailValue>
                    </Col>}
                </Row>
            </CardBody>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        ukonyList: utils.storeFromArea(state, ciselnikActions.UKONY_LIST_AREA),
        objednavkaRights: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_RIGHTS_AREA),
        nakladovaStrediskaList: utils.storeFromArea(state, ciselnikActions.NAKLADOVA_STREDISKA_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(ParametryObjednavkyPanel));
